var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Badge,{attrs:{"icon-before":_setup.priorityIcon,"priority":_setup.priorityName}},[_vm._v("\n  "+_vm._s(_setup.priorityLabel)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }